const NoData = () => (
    <div className={'noData-wrapper'}>
        <div className={'noData'}>
            <span className={'noData-title'}>Brak</span>
            <p className={'noData-subtitle'}>Usuń filtry i spróbuj ponownie</p>
        </div>
    </div>
)

export {NoData}